import React from 'react';
import styled from 'styled-components';

import InputBase from '@mui/material/InputBase';
import IconButton from '@mui/material/IconButton';
import SearchIcon from '@mui/icons-material/Search';

const Wrapper = styled.div`
  width: 100%;
  border-radius: 10px;
  border: 0.9px solid #636363;

  display: flex;
  padding-left: 15px;

  & input {
    font-family:inherit;
    font-size: 14px;
    font-weight: 500;
    background: none;
  }
`;
const SearchWrapper = styled.div`
  display: inline-flex;
  
    transition: background-color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
    padding: 0px;
    color: rgba(7, 51, 88, 1);
    overflow: visible;
    flex: 0 0 auto;
    font-size: 1.5rem;
    user-select: none;
    vertical-align: middle;
    -webkit-tap-highlight-color: transparent;
    background-color: transparent;
    outline: 0;
    border: 0;
    margin: 0;
    justify-content: center;
    position: relative;
    box-sizing: border-box;
    align-items: center;
    -webkit-box-pack: center;
& > svg {


}
`;

const SearchBar = ({
  value,
  onChange,
  placeholder = 'Search...',
  height = '50px',
  onClick = () => { },
}) => {
  return (
    <Wrapper>
      {/* <IconButton
        color='rgba(7, 51, 88, 1)'
        // type='button'
        type="text"
        sx={{ p: '0px', color: 'rgba(7, 51, 88, 1)' }}
        aria-label='search'
        // onClick={onClick}
      > */}
      <SearchWrapper>

        <SearchIcon />
      </SearchWrapper>
      {/* </IconButton> */}
      <InputBase
        sx={{
          ml: 1, flex: 1, width: '85%', height,
          '& .MuiInputBase-input': {
            backgroundColor: 'transparent',
          }
          // bgcolor: 'rgb(240, 255, 240)'
        }}
        placeholder={placeholder}
        inputProps={{ 'aria-label': 'search google maps' }}
        onChange={onChange}
        onClick={onClick}
      />
    </Wrapper>
  );
};

export default SearchBar;
